export const productsAsSurgery = [
  'peeling-prx',
  'ipl-pigmentacion',
  'ipl-mancha-localizada',
  'ipl-vascular',
  'ipl-acne',
  'ipl-rejuvenecimiento',
  'pack-skin-vital',
  'pack-wellaging-platinium',
  'pack-full-revive',
  'pack-lifting',
  'aumento-labios',
  'arrugas-expresion-frente-entrecejo-patas-gallo',
  'proyeccion-pomulos',
  'alidya-anticelulitico',
  'sudoracion-excesiva-axilas',
  'relleno-ojeras',
  'exoglowpeel',
  'exosomas',
  'harmonyca',
  'radiesse',
  'sculptra',
  'aumento-gluteos',
  'firmeza-gluteos',
  'firmeza-brazos',
  'firmeza-abdomen',
  'firmeza-muslos',
  'firmeza-escote',
  'sudoracion-excesiva-pies',
  'sudoracion-excesiva-manos',
  'armonizacion-facial',
  'armonizacion-facial-basic',
  'firmeza-cuello',
  'pack-wellaging',
  'pack-wellaging-esencial',
  'pack-wellaging-plus',
  'marcacion-mandibular',
  'perdida-de-peso-glp-1'
];

export const SURGERY_DATA = [
  {
    id: 'dff080e1-0e53-45c7-ab01-8f38963342a0', //Aumento de mamas
    candidateTitle: '¿Es el aumento de pecho para ti?',
    candiateText: `Indicado para mujeres que buscan mejorar tamaño, forma o simetría de sus senos, ya sea por estética, embarazo, lactancia o pérdida de peso.

    
    Se recomienda tener más de 18 años y desarrollo mamario completo. En la consulta, el cirujano valorará tu anatomía y objetivos para confirmar si eres buena candidata.`,
    candidateBullets: [
      'Desean aumentar el busto',
      'Han perdido volumen mamario',
      'Presentan asimetría en los senos',
      'Tienen expectativas realistas',
      'Gozan de buena salud y estabilidad emocional',
    ],
    typeOfProduct: [
      {
        title: 'Implantes anatómicos',
        description:
          'Diseñados para imitar la forma natural del pecho, con más volumen en la parte inferior, creando un resultado más natural y suave.',
      },
      {
        title: 'Implantes de pecho redondos',
        description:
          'Ofrecen un mayor volumen en la parte superior del pecho, ideales para quienes buscan un escote más pronunciado y definido.',
      },
      {
        title: 'Implantes de gel cohesivo',
        description:
          'Fabricados con un gel de silicona altamente cohesivo, que mantiene su forma incluso en caso de rotura, ofreciendo un tacto natural y alta seguridad.',
      },
      {
        title: 'Implantes de solución salina',
        description:
          'Menos comunes hoy en día, están llenos de solución salina estéril y pueden ser ajustados en tamaño durante la cirugía.',
      },
    ],
    priceTitle: 'Precio del aumento de pecho',
    priceText: `El aumento de pecho se adapta a la anatomía y objetivos estéticos de cada paciente. Por eso, es clave realizar una consulta con el cirujano, quien evaluará el caso y recomendará el tipo de implante y técnica más adecuada.

      El precio del tratamiento varía según el tipo de implante y la complejidad de la cirugía. Como referencia, parte desde {price} €, con un presupuesto final personalizado tras la valoración médica.`,
    priceBullets: [
      'Preoperatorio completo',
      'Implantes mamarios de alta calidad',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados finales?',
        description:
          'Los resultados iniciales se ven inmediatamente después de la cirugía, aunque la forma final se aprecia completamente entre 3-6 meses cuando la inflamación ha desaparecido por completo y los implantes han asentado en su posición definitiva.',
      },
      {
        title: '¿Cuánto duran los implantes mamarios?',
        description:
          'Los implantes mamarios modernos son muy duraderos, pero no son dispositivos de por vida. Se recomienda realizar controles periódicos y la mayoría de los implantes pueden durar entre 10-20 años, aunque algunos pueden durar más tiempo sin problemas.',
      },
      {
        title: '¿Cómo es el proceso de recuperación?',
        description:
          'La recuperación inicial dura aproximadamente 1-2 semanas. Durante este tiempo, es importante evitar esfuerzos físicos intensos. La mayoría de pacientes pueden retomar actividades ligeras en una semana y ejercicio completo después de 6-8 semanas.',
      },
      {
        title: '¿Podré dar el pecho después de la cirugía?',
        description:
          'En la mayoría de los casos, sí es posible dar el pecho después de un aumento mamario. La técnica quirúrgica y la ubicación de la incisión son factores importantes que el cirujano considera para preservar la función de lactancia.',
      },
    ],
  },
  {
    id: '0fec281e-2599-4ca6-8361-fa8ad53f2e3c', //Rinoplastia
    candidateTitle: '¿Eres un buen candidatx para una rinoplastia?',
    candiateText: `Durante la consulta inicial, nuestros especialistas evaluarán tu caso particular y te explicarán las opciones más adecuadas para conseguir tus objetivos.
    
    La rinoplastia es adecuada si:`,
    candidateBullets: [
      'Tienes más de 16-17 años (desarrollo nasal completo)',
      'Presentas problemas estéticos o funcionales nasales',
      'Tienes expectativas realistas sobre los resultados',
      'Gozas de buena salud general',
      'No fumas o estás dispuesto a dejarlo temporalmente',
    ],
    priceTitle: 'Precio de la rinoplastia',
    priceText: `El precio de la rinoplastia depende de la técnica empleada y de las características de cada paciente. Como referencia, parte desde {price} €, con presupuesto final tras consulta médica personalizada.`,
    priceBullets: [
      'Preoperatorio completo',
      'Cirugía de rinoplastia (funcional y/o estética)',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados finales de la rinoplastia?',
        description:
          'Los primeros cambios se notan a las 2-3 semanas, cuando baja la inflamación. El resultado definitivo aparece entre 6 y 12 meses, una vez la nariz adopta su forma final.',
      },
      {
        title: '¿Es dolorosa la rinoplastia?',
        description:
          'No suele ser dolorosa. Las molestias son leves, se controlan con analgésicos y lo más común es la congestión nasal los primeros días.',
      },
      {
        title: '¿Cuánto dura la recuperación de la rinoplastia?',
        description:
          'La recuperación inicial es de 1-2 semanas. El yeso se retira a los 7-10 días. Actividades normales en 2 semanas y ejercicio intenso tras 6 semanas.',
      },
      {
        title: '¿Quedarán cicatrices visibles tras la rinoplastia?',
        description:
          'En la rinoplastia cerrada no hay cicatrices externas. En la abierta, queda una pequeña cicatriz en la columela que con el tiempo casi no se nota.',
      },
      {
        title: '¿Cuánto duran los resultados de una rinoplastia?',
        description:
          'Los resultados son permanentes. Una vez consolidada la cicatrización y la forma definitiva de la nariz, solo el envejecimiento natural puede generar cambios leves con el tiempo.',
      },
    ],
  },
  {
    id: '2e2a0ae2-7fa0-4433-9632-7f95090b4440', //Reducción de mamas
    candidateTitle: '¿Es la reducción de pecho para ti?',
    candiateText: `Debes haber completado el desarrollo mamario y no estar embarazada ni en lactancia. El cirujano valorará tu anatomía, síntomas y objetivos para confirmar si eres candidata.

    La reducción de pecho está indicada para mujeres que sufren molestias físicas o desean senos más proporcionados a su cuerpo. Algunos signos comunes:`,
    candidateBullets: [
      'Dolor en espalda, cuello u hombros',
      'Irritación bajo el pecho o por el sujetador',
      'Dificultad para hacer deporte o vestirse cómoda',
      'Deseo de mejorar la proporción corporal',
      'Buena salud y expectativas realistas',
    ],
    priceTitle: 'Precio de la reducción de pecho',
    priceText: `El precio de la mamoplastia de reducción depende del grado de reducción, la técnica y la anatomía de cada paciente. Como referencia, parte desde {price} €, con presupuesto final tras consulta médica personalizada.`,
    priceBullets: [
      'Preoperatorio completo',
      'Cirugía completa de reducción mamaria',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados finales de la reducción de pecho?',
        description:
          'Los primeros resultados se notan tras la cirugía, pero la forma definitiva aparece entre 3 y 6 meses, cuando baja la inflamación y cicatrizan los tejidos.',
      },
      {
        title: '¿Cómo serán las cicatrices tras la reducción de pecho?',
        description:
          'Dependen de la técnica usada, pero con el tiempo se vuelven más discretas y claras. Seguir las indicaciones postoperatorias ayuda a una mejor cicatrización.',
      },
      {
        title: '¿Cómo es la recuperación tras una reducción de pecho?',
        description:
          'La recuperación inicial dura 2-3 semanas, evitando esfuerzos físicos. La mayoría retoma actividades normales poco a poco y ejercicio completo a las 6-8 semanas.',
      },
      {
        title: '¿Podré dar el pecho después de una reducción mamaria?',
        description:
          'En muchos casos sí es posible, sobre todo con técnicas que preservan los conductos. Depende del procedimiento y debe valorarse en la consulta.',
      },
      {
        title: '¿Cuánto duran los resultados de una reducción de pecho?',
        description:
          'Los resultados son duraderos. Se mantienen a largo plazo, aunque pueden verse afectados por factores como embarazo, lactancia, cambios de peso o envejecimiento natural.',
      },
    ],
  },
  {
    id: 'e3b06bd8-dec0-4871-b317-ac25ea03d8bd', //Blefaroplastia unilateral
    candidateTitle:
      '¿Eres un buen candidatx para una blefaroplastia unilateral?',
    candiateText: `La blefaroplastia unilateral está indicada si presentas caída o exceso de piel en un solo párpado superior que afecte la mirada o el campo visual.
    
    El cirujano evaluará tu anatomía, grado de ptosis y objetivos para confirmar si este tratamiento es el más adecuado.`,
    candidateBullets: [
      'Exceso de piel o grasa en un párpado',
      'Pérdida de simetría o mirada cansada',
      'Campo visual reducido',
      'Buen estado de salud general',
      'Expectativas realistas',
    ],
    priceTitle: 'Precio de la blefaroplastia unilateral',
    priceText: `El precio de la blefaroplastia unilateral varía según la técnica y complejidad del párpado. Como referencia, parte desde {price} €, con presupuesto final tras consulta médica personalizada.`,
    priceBullets: [
      'Preoperatorio completo',
      'Cirugía especializada en párpados',
      'Anestesia local con sedación',
      'Quirófanos propios',
      'Seguimiento postoperatorio',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title:
          '¿Cuándo veré los resultados finales de la blefaroplastia unilateral?',
        description:
          'Los primeros cambios se notan tras la cirugía, pero el resultado definitivo aparece a los 2-3 meses, cuando baja la inflamación y cicatrizan los tejidos.',
      },
      {
        title:
          '¿Quedarán cicatrices visibles tras la blefaroplastia unilateral?',
        description:
          'No, las incisiones siguen el pliegue natural del párpado, por lo que al cicatrizar se vuelven casi imperceptibles.',
      },
      {
        title: '¿Cómo es la recuperación tras la blefaroplastia unilateral?',
        description:
          'Dura unos 7-10 días. Es normal tener inflamación o pequeños hematomas que desaparecen gradualmente. La mayoría retoma actividades normales en una semana.',
      },
      {
        title: '¿Cuánto duran los resultados de la blefaroplastia unilateral?',
        description:
          'Los resultados suelen mantenerse entre 10 y 15 años. Aunque el envejecimiento natural sigue su curso, la mejoría lograda en el párpado tratado se conserva a largo plazo.',
      },
    ],
  },
  {
    id: 'ba735b67-0f65-4660-8227-183de350f325', //Blefaroplastia bilateral
    candidateTitle:
      '¿Eres un buen candidatx para una blefaroplastia bilateral?',
    candiateText: `La blefaroplastia bilateral está indicada para quienes desean corregir el envejecimiento en ambos párpados, mejorar el campo visual y rejuvenecer la expresión facial.
    
    El cirujano valorará tu anatomía, el estado de los párpados y tus objetivos para confirmar si la blefaroplastia bilateral es el tratamiento más adecuado.`,
    candidateBullets: [
      'Bolsas y caída del párpado',
      'Exceso de piel que afecta la visión',
      'Deseo de mirada joven y simétrica',
      'Buena salud y expectativas realistas',
      'Piel con elasticidad adecuada',
    ],
    priceTitle: 'Precio de la blefaroplastia unilateral',
    priceText: `El precio de la blefaroplastia bilateral varía según el nivel de corrección y la técnica empleada. Como referencia, parte desde {price} €, con presupuesto final tras la consulta médica personalizada.`,
    priceBullets: [
      'Preoperatorio completo',
      'Cirugía en párpados superiores e inferiores',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title:
          '¿Cuándo veré los resultados finales de la blefaroplastia bilateral?',
        description:
          'Los primeros cambios se notan tras la cirugía, pero el resultado definitivo aparece entre 2 y 3 meses, cuando baja la inflamación y cicatrizan los tejidos.',
      },
      {
        title: '¿Las cicatrices de la blefaroplastia bilateral serán visibles?',
        description:
          'No, las incisiones se hacen en los pliegues naturales de los párpados y, con el tiempo, se vuelven casi imperceptibles.',
      },
      {
        title: '¿Cómo es la recuperación tras la blefaroplastia bilateral?',
        description:
          'Dura unos 7-10 días. Es normal tener inflamación o moratones que desaparecen gradualmente. La mayoría retoma actividades normales en una semana.',
      },
      {
        title: '¿Cuánto duran los resultados de la blefaroplastia bilateral?',
        description:
          'Los resultados suelen durar entre 10 y 15 años. Aunque el envejecimiento continúa, la mejora obtenida se mantiene a largo plazo.',
      },
    ],
  },
  {
    id: 'fec3f1b2-3638-44b2-8fa4-f1d4fc38761e', //Otoplastia
    candidateTitle: '¿Eres un buen candidatx para una otoplastia?',
    candiateText: `La otoplastia está indicada para personas que desean corregir la forma, tamaño o posición de sus orejas.
    
    Los candidatos ideales gozan de buena salud y expectativas realistas. En niños, se recomienda desde los 5-6 años, cuando el cartílago está desarrollado`,
    candidateBullets: [
      'Orejas prominentes o separadas ("en asa")',
      'Diferencias notables entre ambas orejas',
      'Tamaño excesivo o desproporcionado',
      'Deformidades congénitas o por traumatismo',
      'Mejora de la confianza y autoestima',
    ],
    priceTitle: 'Precio de la otoplastia',
    priceText: `El precio de la otoplastia varía según la corrección y técnica empleada. Cada caso se evalúa de forma personalizada en consulta. Como referencia, parte desde {price} €, con presupuesto final tras la valoración médica.`,
    priceBullets: [
      'Consulta preoperatoria completa',
      'Anestesia especializada',
      'Quirófano equipado',
      'Material quirúrgico',
      'Atención de enfermería',
      'Seguimiento post-operatorio',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados de la otoplastia?',
        description:
          'Son visibles de inmediato, aunque la forma final se aprecia entre 2 y 4 semanas, cuando baja la inflamación. Los resultados son permanentes y muy satisfactorios.',
      },
      {
        title: '¿Cuál es la edad mínima para una otoplastia?',
        description:
          'Puede realizarse desde los 5-6 años, cuando el cartílago está desarrollado. En adultos no hay límite de edad siempre que tengan buena salud.',
      },
      {
        title: '¿Es dolorosa la otoplastia?',
        description:
          'No, solo causa molestias leves los primeros días, como presión o incomodidad, que se controlan con analgésicos. La mayoría retoma sus actividades en pocos días.',
      },
      {
        title: '¿Cómo es la recuperación tras la otoplastia?',
        description:
          'La recuperación inicial dura 7-10 días, con ligera inflamación o molestias. La mayoría de pacientes retoma sus actividades normales en una semana.',
      },
      {
        title: '¿Cuánto duran los resultados de la otoplastia?',
        description:
          'Los resultados son permanentes. Una vez corregida la forma y posición de las orejas, se mantienen estables de por vida.',
      },
    ],
  },
  {
    id: '08f5507d-cc06-4f68-bfa3-7d17bfe4d2d1', //Abdominopolastia
    candidateTitle: '¿Eres un buen candidatx para una abdominoplastia?',
    candiateText: `Los mejores candidatos tienen peso estable, buena salud y expectativas realistas. En mujeres, se aconseja realizarla tras completar los embarazos.

La abdominoplastia no sustituye una vida saludable, sino que la complementa en casos donde dieta y ejercicio no son suficientes

La abdominoplastia está indicada para personas que desean:`,
    candidateBullets: [
      'Eliminar exceso de piel y grasa abdominal resistente a dieta y ejercicio',
      'Corregir la diástasis de rectos (separación muscular)',
      'Mejorar la apariencia de estrías en la zona baja del abdomen',
      'Lograr un abdomen más plano, firme y tonificado',
      'Sentirse mejor con su imagen y ganar autoestima',
    ],
    priceTitle: 'Precio de la abdominoplastia',
    priceText: `El precio de la abdominoplastia depende de la técnica y complejidad del caso. Cada tratamiento se personaliza tras la consulta con el cirujano. Como referencia, parte desde {price} €, con presupuesto final tras la valoración médica.`,
    priceBullets: [
      'Preoperatorio completo',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización',
      'Enfermería',
      'Servicio postratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados de la abdominoplastia?',
        description:
          'Los primeros cambios se notan tras la cirugía, pero los resultados finales aparecen entre 6 y 12 meses, una vez que la inflamación y cicatrización han terminado.',
      },
      {
        title: '¿Cuánto dura la recuperación de la abdominoplastia?',
        description:
          'La recuperación inicial es de 2-3 semanas. El trabajo sedentario puede retomarse en 1-2 semanas y el ejercicio intenso tras 6-8 semanas, siguiendo siempre las indicaciones del cirujano.',
      },
      {
        title: '¿Cómo será la cicatriz tras una abdominoplastia?',
        description:
          'La cicatriz queda en la parte baja del abdomen, oculta bajo la ropa interior o el bikini. Al inicio es rojiza, pero con el tiempo se vuelve más clara y discreta, siempre con los cuidados adecuados.',
      },
      {
        title: '¿Es dolorosa la abdominoplastia?',
        description:
          'No suele ser dolorosa. Puede haber molestias o tirantez los primeros días, controladas con analgésicos. La mayoría de pacientes se recupera de forma progresiva y confortable.',
      },
      {
        title: '¿Cuánto duran los resultados de la abdominoplastia?',
        description:
          'Los resultados son duraderos siempre que se mantenga un peso estable y un estilo de vida saludable. Sin embargo, grandes cambios de peso o embarazos pueden afectarlos.',
      },
    ],
  },
  {
    id: 'a019c704-6cee-4923-9451-2b935c6bacde', //Miniliposucción
    candidateTitle: '¿Eres un buen candidatx para una Miniliposucción?',
    candiateText: `Los mejores candidatos tienen peso estable, buena salud y expectativas realistas. En todos los casos, es fundamental la valoración personalizada del cirujano para confirmar la idoneidad del tratamiento.
    
    La miniliposucción está indicada para personas que desean:`,
    candidateBullets: [
      'Eliminar pequeños cúmulos de grasa localizada resistentes a dieta y ejercicio',
      'Definir contornos en zonas como papada, abdomen bajo, brazos o muslos',
      'Mejorar la proporción corporal de forma natural',
      'Conseguir resultados rápidos con mínima invasión',
      'Sentirse mejor con su imagen y ganar confianza',
    ],
    priceTitle: 'Precio de la liposucción',
    priceText: `El precio de la miniliposucción depende de la técnica y la complejidad del caso.
Cada tratamiento se personaliza tras la consulta con el cirujano. Como referencia, parte desde {price} €, con presupuesto final tras la valoración médica.`,
    priceBullets: [
      'Preoperatorio completo',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización (si es necesaria)',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados de la miniliposucción?',
        description:
          'Los cambios se notan en pocos días, aunque los resultados finales aparecen tras 1-3 meses, cuando la inflamación desaparece por completo.',
      },
      {
        title: '¿Cuánto dura la recuperación de la miniliposucción?',
        description:
          'La recuperación suele ser rápida. La mayoría de pacientes retoma actividades normales en 3-7 días y ejercicio ligero tras 2 semanas.',
      },
      {
        title: '¿La miniliposucción deja cicatrices visibles?',
        description:
          'No, las incisiones son muy pequeñas (1-2 mm) y quedan ocultas en pliegues naturales, volviéndose casi imperceptibles con el tiempo.',
      },
      {
        title: '¿Es dolorosa la miniliposucción?',
        description:
          'No suele ser dolorosa. Se realiza con anestesia local o sedación y las molestias postoperatorias son leves y fáciles de controlar.',
      },
      {
        title: '¿Cuánto duran los resultados de la miniliposucción?',
        description:
          'Los resultados son duraderos siempre que mantengas un peso estable y hábitos saludables. Los aumentos de peso pueden afectar el resultado.',
      },
    ],
  },
  {
    id: '70969E20-3A05-4FDA-8F11-96EAE3C7D367', //Liposucción mediana
    candidateTitle: '¿Eres un buen candidatx para una Liposucción Mediana?',
    candiateText: `Los mejores candidatos tienen peso estable, buena salud y expectativas realistas. La valoración personalizada del cirujano confirma la idoneidad del tratamiento.
    
    La liposucción mediana está indicada para personas que desean:`,
    candidateBullets: [
      'Eliminar grasa localizada en 2-3 zonas (abdomen, flancos, muslos, glúteos, brazos).',
      'Mejorar la silueta corporal de forma armónica.',
      'Conseguir resultados naturales y visibles en poco tiempo.',
      'Lograr un contorno más definido con una cirugía segura.',
      'Sentirse mejor con su imagen y ganar confianza.',
    ],
    priceTitle: 'Precio de la Liposucción Mediana',
    priceText: `El coste de la liposucción mediana varía según la técnica empleada y la complejidad de cada caso. El presupuesto se define tras la valoración personalizada con el cirujano. Como orientación, el precio parte desde {price} €, ajustándose tras la consulta médica.`,
    priceBullets: [
      'Preoperatorio completo',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización (si es necesaria)',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados de la liposucción mediana?',
        description:
          'Los cambios son visibles en pocas semanas, aunque el resultado final aparece entre 1 y 3 meses, cuando la inflamación baja por completo.',
      },
      {
        title: '¿Cuánto dura la recuperación de la liposucción mediana?',
        description:
          'La recuperación suele ser rápida. La mayoría de pacientes vuelve a sus rutinas en 7-10 días y al ejercicio tras 3-4 semanas',
      },
      {
        title: '¿La liposucción mediana deja cicatrices visibles?',
        description:
          'No, las incisiones son pequeñas (2-3 mm) y se esconden en pliegues naturales, haciéndose poco perceptibles con el tiempo.',
      },
      {
        title: '¿Es dolorosa la liposucción mediana?',
        description:
          'No suele ser dolorosa. Se realiza con anestesia local o sedación y las molestias postoperatorias son leves y fáciles de controlar.',
      },
      {
        title: '¿Cuánto duran los resultados de la liposucción mediana?',
        description:
          'Los resultados son duraderos si mantienes un peso estable y hábitos saludables. Los aumentos de peso pueden alterar el resultado.',
      },
    ],
  },
  {
    id: '90C02342-885F-4EED-92C8-E5CB80454E98', //Lipoescultura
    candidateTitle: '¿Eres un buen candidatx para una Lipoescultura?',
    candiateText: `Los mejores candidatos mantienen peso estable, buena salud y expectativas realistas. La valoración médica confirmará si es el tratamiento adecuado.
    
    La lipoescultura está indicada para personas que desean:`,
    candidateBullets: [
      'Eliminar grasa acumulada en varias zonas (abdomen, cintura, espalda, flancos, muslos o brazos).',
      'Definir contornos y mejorar la proporción corporal.',
      'Conseguir un resultado armónico y natural en menos tiempo.',
      'Lograr mayor firmeza y realce muscular.',
      'Sentirse más cómodos con su silueta y aumentar la confianza.',
    ],
    priceTitle: 'Precio de la Liposucción Mediana',
    priceText: `El coste de la lipoescultura depende del número de zonas tratadas y la complejidad del procedimiento. El presupuesto se establece tras la valoración personalizada con el cirujano. Como referencia, el precio parte desde {price} €, ajustándose tras la consulta médica.`,
    priceBullets: [
      'Preoperatorio completo',
      'Anestesista especializado',
      'Quirófanos propios',
      'Hospitalización (si es necesaria)',
      'Enfermería especializada',
      'Servicio post-tratamiento 24 horas',
    ],
    faqs: [
      {
        title: '¿Cuándo veré los resultados de la lipoescultura?',
        description:
          'Los cambios se aprecian en pocas semanas, aunque el resultado final se observa entre 2 y 4 meses, cuando la inflamación desaparece por completo.',
      },
      {
        title: '¿Cuánto dura la recuperación de la lipoescultura?',
        description:
          'La recuperación inicial suele ser de 10 a 15 días. La mayoría de pacientes retoma actividades normales en ese periodo y el ejercicio progresivo tras 4-6 semanas.',
      },
      {
        title: '¿La lipoescultura deja cicatrices visibles?',
        description:
          'No, las incisiones son pequeñas (2-3 mm) y se colocan en pliegues naturales, por lo que con el tiempo resultan apenas perceptibles.',
      },
      {
        title: '¿Es dolorosa la lipoescultura?',
        description:
          'No suele ser dolorosa. Se realiza con anestesia general o sedación y las molestias postoperatorias son controlables con medicación.',
      },
      {
        title: '¿Cuánto duran los resultados de la lipoescultura?',
        description:
          'Los resultados son duraderos si mantienes un peso estable y hábitos saludables. Cambios importantes de peso pueden afectar el resultado.',
      },
    ],
  },
  {
    id: '48b51874-c0d0-4384-aa19-b10ffcd4ae3b', //Peeling PRX
    candidateTitle: 'Paciente ideal para el Peeling PRX',
    candiateText: `El Peeling PRX está indicado para quienes desean mejorar la calidad, firmeza y luminosidad de su piel sin recurrir a procedimientos invasivos ni periodos de recuperación.

Ideal para quienes:`,
    candidateBullets: [
      'Quieren rejuvenecer la piel de forma inmediata y natural.',
      'Buscan reducir manchas, cicatrices o estrías.',
      'Desean mejorar la textura y luminosidad cutánea.',
      'Tienen la piel apagada o con signos de fatiga.',
      'Buscan un tratamiento seguro y eficaz todo el año, incluso en verano.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Puedo continuar con mi vida habitual después del tratamiento?',
        description:
          'Por supuesto, podrás continuar con tu rutina sin complicaciones aunque pueden aparecer enrojecimiento o cambios de color temporales.',
      },
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Después de un solo tratamiento, obtendrás un tono de piel más uniforme y radiante visible. De todos modos, para lograr resultados más duraderos te recomendamos realizar sesiones de forma continuada.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description:
          'La aplicación del tratamiento no es dolorosa pero puede generar sensaciones de escozor y picor durante el procedimiento. No se aplica crema anestésica ya que dificultaría la penetración del peeling.',
      },
    ],
  },
  {
    id: 'AFC8DD08-5BAF-4443-BBB7-901F3BD86456', //IPL Pigmentación
    candidateTitle:
      'Paciente ideal para el tratamiento IPL para la Pigmentación',
    candiateText: `Este tratamiento está indicado para personas que buscan reducir manchas, mejorar el tono de uniformidad de la piel o tratar los efectos del sol y la edad, siempre con un enfoque seguro y personalizado.

Ideal para quienes:`,
    candidateBullets: [
      'Desean un tono de piel más homogéneo y luminoso.',
      'Buscan tratar manchas solares o pecas.',
      'Quieren mejorar la textura sin procedimientos invasivos.',
      'Tienen expectativas realistas y buena salud general.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es la tecnología IPL?',
        description:
          'La Luz Pulsada Intensa (IPL) es una tecnología estética no invasiva que emite pulsos de luz de alta intensidad capaces de actuar sobre diferentes estructuras de la piel (melanina, vasos sanguíneos o glándulas sebáceas) para tratar manchas, rojeces, acné y signos de envejecimiento',
      },
      {
        title: '¿Los tratamientos IPL son seguros?',
        description:
          'Sí. Los tratamientos IPL se realizan con equipos de última generación y bajo valoración médica previa, ajustando la intensidad según el tipo y estado de la piel para garantizar seguridad y eficacia.',
      },
      {
        title: '¿Duele el tratamiento IPL?',
        description:
          'La sensación es leve y bien tolerada. Puede notarse un pequeño calor o pinchazo momentáneo durante los pulsos de luz, pero no requiere anestesia.',
      },
      {
        title: '¿Necesito tiempo de recuperación después de una sesión IPL?',
        description:
          'No. Los tratamientos IPL no requieren baja médica ni tiempo de recuperación. Puedes retomar tu rutina diaria inmediatamente tras la sesión.',
      },
      {
        title: '¿Cuántas sesiones de IPL se recomiendan?',
        description:
          'El número de sesiones de IPL depende del tipo de tratamiento, del estado de la piel y de los objetivos de cada paciente. De forma general, se recomienda realizar entre 3 y 6 sesiones para obtener resultados visibles, progresivos y duraderos.',
      },
      {
        title: '¿Cuándo se empiezan a ver los resultados?',
        description:
          'Los resultados suelen ser visibles desde las primeras sesiones, aunque mejoran de forma progresiva con el número de tratamientos realizados.',
      },
    ],
  },
  {
    id: '8346E058-FAD3-47DF-AF32-E9AB5E350D74', //IPL Mancha localizada
    candidateTitle: 'Paciente ideal para el tratamiento IPL Mancha Localizada',
    candiateText: `Este tratamiento está indicado para personas que desean tratar una mancha concreta del rostro de forma eficaz, segura y personalizada.

Ideal para quienes:`,
    candidateBullets: [
      'Presentan una mancha solar, peca o hiperpigmentación puntual.',
      'Buscan una solución rápida y localizada.',
      'No necesitan un tratamiento facial completo.',
      'Desean mejorar el aspecto de una zona específica del rostro.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es la tecnología IPL?',
        description:
          'La Luz Pulsada Intensa (IPL) es una tecnología estética no invasiva que emite pulsos de luz de alta intensidad capaces de actuar sobre diferentes estructuras de la piel (melanina, vasos sanguíneos o glándulas sebáceas) para tratar manchas, rojeces, acné y signos de envejecimiento',
      },
      {
        title: '¿Los tratamientos IPL son seguros?',
        description:
          'Sí. Los tratamientos IPL se realizan con equipos de última generación y bajo valoración médica previa, ajustando la intensidad según el tipo y estado de la piel para garantizar seguridad y eficacia.',
      },
      {
        title: '¿Duele el tratamiento IPL?',
        description:
          'La sensación es leve y bien tolerada. Puede notarse un pequeño calor o pinchazo momentáneo durante los pulsos de luz, pero no requiere anestesia.',
      },
      {
        title: '¿Necesito tiempo de recuperación después de una sesión IPL?',
        description:
          'No. Los tratamientos IPL no requieren baja médica ni tiempo de recuperación. Puedes retomar tu rutina diaria inmediatamente tras la sesión.',
      },
      {
        title: '¿Cuántas sesiones de IPL se recomiendan?',
        description:
          'El número de sesiones de IPL depende del tipo de tratamiento, del estado de la piel y de los objetivos de cada paciente. De forma general, se recomienda realizar entre 3 y 6 sesiones para obtener resultados visibles, progresivos y duraderos.',
      },
      {
        title: '¿Cuándo se empiezan a ver los resultados?',
        description:
          'Los resultados suelen ser visibles desde las primeras sesiones, aunque mejoran de forma progresiva con el número de tratamientos realizados.',
      },
    ],
  },
  {
    id: 'DBFD45E7-DB69-45CA-888C-F5D77E68CC3A', //IPL Vascular
    candidateTitle: 'Paciente ideal para el tratamiento IPL Vascular',
    candiateText: `El tratamiento IPL Vascular está indicado para quienes presentan rojeces, capilares visibles o cuperosis, y desean mejorar el aspecto y la salud de su piel de forma segura y eficaz.

Ideal para quienes:`,
    candidateBullets: [
      'Quieren reducir rojeces o vasos capilares en rostro.',
      'Presentan cuperosis, rosácea leve o enrojecimiento difuso.',
      'Buscan mejorar la uniformidad y luminosidad del cutis.',
      'Tienen expectativas realistas y buena salud general.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es la tecnología IPL?',
        description:
          'La Luz Pulsada Intensa (IPL) es una tecnología estética no invasiva que emite pulsos de luz de alta intensidad capaces de actuar sobre diferentes estructuras de la piel (melanina, vasos sanguíneos o glándulas sebáceas) para tratar manchas, rojeces, acné y signos de envejecimiento',
      },
      {
        title: '¿Los tratamientos IPL son seguros?',
        description:
          'Sí. Los tratamientos IPL se realizan con equipos de última generación y bajo valoración médica previa, ajustando la intensidad según el tipo y estado de la piel para garantizar seguridad y eficacia.',
      },
      {
        title: '¿Duele el tratamiento IPL?',
        description:
          'La sensación es leve y bien tolerada. Puede notarse un pequeño calor o pinchazo momentáneo durante los pulsos de luz, pero no requiere anestesia.',
      },
      {
        title: '¿Necesito tiempo de recuperación después de una sesión IPL?',
        description:
          'No. Los tratamientos IPL no requieren baja médica ni tiempo de recuperación. Puedes retomar tu rutina diaria inmediatamente tras la sesión.',
      },
      {
        title: '¿Cuántas sesiones de IPL se recomiendan?',
        description:
          'El número de sesiones de IPL depende del tipo de tratamiento, del estado de la piel y de los objetivos de cada paciente. De forma general, se recomienda realizar entre 3 y 6 sesiones para obtener resultados visibles, progresivos y duraderos.',
      },
      {
        title: '¿Cuándo se empiezan a ver los resultados?',
        description:
          'Los resultados suelen ser visibles desde las primeras sesiones, aunque mejoran de forma progresiva con el número de tratamientos realizados.',
      },
    ],
  },
  {
    id: '8A14FEC9-34F7-4368-B5DC-4E1EEB6B1250', //IPL Acne
    candidateTitle: 'Paciente ideal para el tratamiento IPL para el acné',
    candiateText: `El tratamiento IPL para acné está indicado para personas con acné activo (bajo diagnóstico médico), marcas postinflamatorias o piel con tendencia grasa, que buscan mejorar el aspecto y la salud de su piel de forma no invasiva.

Ideal para quienes:`,
    candidateBullets: [
      'Presentan acné leve o moderado.',
      'Quieren reducir la inflamación y las rojeces.',
      'Buscan mejorar la textura y prevenir nuevos brotes.',
      'Desean complementar su rutina facial con un tratamiento estético avanzado.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es la tecnología IPL?',
        description:
          'La Luz Pulsada Intensa (IPL) es una tecnología estética no invasiva que emite pulsos de luz de alta intensidad capaces de actuar sobre diferentes estructuras de la piel (melanina, vasos sanguíneos o glándulas sebáceas) para tratar manchas, rojeces, acné y signos de envejecimiento',
      },
      {
        title: '¿Los tratamientos IPL son seguros?',
        description:
          'Sí. Los tratamientos IPL se realizan con equipos de última generación y bajo valoración médica previa, ajustando la intensidad según el tipo y estado de la piel para garantizar seguridad y eficacia.',
      },
      {
        title: '¿Duele el tratamiento IPL?',
        description:
          'La sensación es leve y bien tolerada. Puede notarse un pequeño calor o pinchazo momentáneo durante los pulsos de luz, pero no requiere anestesia.',
      },
      {
        title: '¿Necesito tiempo de recuperación después de una sesión IPL?',
        description:
          'No. Los tratamientos IPL no requieren baja médica ni tiempo de recuperación. Puedes retomar tu rutina diaria inmediatamente tras la sesión.',
      },
      {
        title: '¿Cuántas sesiones de IPL se recomiendan?',
        description:
          'El número de sesiones de IPL depende del tipo de tratamiento, del estado de la piel y de los objetivos de cada paciente. De forma general, se recomienda realizar entre 3 y 6 sesiones para obtener resultados visibles, progresivos y duraderos.',
      },
      {
        title: '¿Cuándo se empiezan a ver los resultados?',
        description:
          'Los resultados suelen ser visibles desde las primeras sesiones, aunque mejoran de forma progresiva con el número de tratamientos realizados.',
      },
    ],
  },
  {
    id: '8D3C29DB-DDF5-4DCD-A449-F37495CDA2FF', //Pack Skin Vital
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Pack Skin Vital',
    candiateText: 'El Pack Skin Vital está indicado para personas que desean mejorar la calidad, la hidratación y la luminosidad de su piel mediante un tratamiento médico mínimamente invasivo. Es ideal si:',
    candidateBullets: [
      'Notas la piel apagada, deshidratada o con pérdida de firmeza',
      'Buscas prevenir o tratar los primeros signos de envejecimiento',
      'Quieres un tratamiento facial completo y personalizado',
      'Deseas resultados progresivos sin tiempo de recuperación',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. En Holaglow disponemos de un escáner facial 3D gratuito, que te permite visualizar el resultado de tu tratamiento antes de realizarlo, siempre acompañado del asesoramiento personalizado de nuestros especialistas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Pack Skin Vital',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece una mejora de la hidratación visible desde el primer momento, mientras que el efecto del IPL Rejuvenecimiento se desarrolla de forma progresiva, a medida que se estimula la producción de colágeno y elastina en las semanas posteriores al tratamiento.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del Pack Skin Vital?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. La duración depende de la zona tratada y del metabolismo de cada paciente, y varía según el tratamiento aplicado.',
      },
      {
        title: '¿La aplicación del Pack Skin Vital es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '914501CD-7975-46D4-B784-7C2C8C933E4A', //IPL Rejuvenecimiento
    candidateTitle:
      'Paciente ideal para el tratamiento IPL para el rejuvenecimiento',
    candiateText: `Este tratamiento está indicado para personas que buscan mejorar la firmeza, textura y luminosidad de su piel sin recurrir a procedimientos invasivos.

Ideal para quienes:`,
    candidateBullets: [
      'Desean revitalizar la piel y recuperar su brillo natural.',
      'Buscan atenuar líneas de expresión finas o flacidez leve.',
      'Quieren mejorar la textura y uniformidad del rostro.',
      'Tienen expectativas realistas y buena salud general.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es la tecnología IPL?',
        description:
          'La Luz Pulsada Intensa (IPL) es una tecnología estética no invasiva que emite pulsos de luz de alta intensidad capaces de actuar sobre diferentes estructuras de la piel (melanina, vasos sanguíneos o glándulas sebáceas) para tratar manchas, rojeces, acné y signos de envejecimiento',
      },
      {
        title: '¿Los tratamientos IPL son seguros?',
        description:
          'Sí. Los tratamientos IPL se realizan con equipos de última generación y bajo valoración médica previa, ajustando la intensidad según el tipo y estado de la piel para garantizar seguridad y eficacia.',
      },
      {
        title: '¿Duele el tratamiento IPL?',
        description:
          'La sensación es leve y bien tolerada. Puede notarse un pequeño calor o pinchazo momentáneo durante los pulsos de luz, pero no requiere anestesia.',
      },
      {
        title: '¿Necesito tiempo de recuperación después de una sesión IPL?',
        description:
          'No. Los tratamientos IPL no requieren baja médica ni tiempo de recuperación. Puedes retomar tu rutina diaria inmediatamente tras la sesión.',
      },
      {
        title: '¿Cuántas sesiones de IPL se recomiendan?',
        description:
          'El número de sesiones de IPL depende del tipo de tratamiento, del estado de la piel y de los objetivos de cada paciente. De forma general, se recomienda realizar entre 3 y 6 sesiones para obtener resultados visibles, progresivos y duraderos.',
      },
      {
        title: '¿Cuándo se empiezan a ver los resultados?',
        description:
          'Los resultados suelen ser visibles desde las primeras sesiones, aunque mejoran de forma progresiva con el número de tratamientos realizados.',
      },
    ],
  },
  {
    id: '94F9F4F8-B10B-4AB8-92DE-8E48CBC2AC85', //Pack  Wellaging Platinium
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para Pack Wellaging Platinium',
    candiateText: 'El Pack Wellaging Platinium está recomendado para quienes buscan un rejuvenecimiento facial completo y personalizable, combinando el efecto suavizante del inyectable antiarrugas con la capacidad de restauración de volumen del ácido hialurónico. Este tratamiento estético es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión en el tercio superior del rostro',
      'Has perdido volumen o firmeza en pómulos, labios u otras zonas faciales',
      'Buscas un resultado natural, progresivo y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre Pack Wellaging Platinium',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Pack Wellaging Platinium?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados del Pack Wellaging Platinium tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación de Pack Wellaging Platinium es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Pack Wellaging Platinium?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '794FEC97-319A-426B-8B64-0509A03D2AAA', //Pack Full Revive
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Pack Full Revive',
    candiateText: 'El Pack Full Revive está indicado para personas que desean un rejuvenecimiento facial profundo, completo y duradero. Es ideal si:',
    candidateBullets: [
      'Presentas arrugas de expresión marcadas',
      'Notas flacidez, pérdida de firmeza y de colágeno',
      'Has perdido volumen facial',
      'Observas una piel más fina, menos elástica o con menor densidad',
      'Deseas redefinir el óvalo y los contornos',
      'Quieres prevenir y corregir el envejecimiento de forma global',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. En Holaglow disponemos de un Escáner Facial 3D gratuito, que te permite visualizar el resultado de tu tratamiento antes de realizarlo, siempre acompañado del asesoramiento personalizado de nuestros especialistas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Pack Full Revive',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas. La hidroxiapatita cálcica estimula el colágeno de forma gradual, por lo que la mejora de la firmeza se aprecia de forma progresiva en las semanas siguientes.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del Pack Full Revive?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. La duración depende de la zona tratada y del metabolismo de cada paciente, y varía según el producto aplicado.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el Pack Full Revive?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'ACFCF794-AD18-411B-AAC6-940784ED4702', //Pack Lifting
    candidateTitle: 'Paciente ideal para el Pack Lifting',
    candiateText: `El Pack Lifting está indicado para personas que desean mejorar la firmeza y el contorno del rostro sin aportar volumen.

Es ideal para quienes:`,
    candidateBullets: [
      'Notan flacidez o descolgamiento facial',
      'Han perdido firmeza y colágeno',
      'Desean redefinir el óvalo facial o el contorno del cuello',
      'Buscan un efecto tensor natural',
      'Quieren un tratamiento sin cirugía',
      'Desean prevenir o corregir la flacidez de forma progresiva',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación de hidroxiapatita cálcica es dolorosa?',
        description:
          'La aplicación de hidroxiapatita cálcica no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title:
          '¿Cuánto tiempo duran los resultados de la hidroxiapatita cálcica?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de la hidroxiapatita cálcica se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 12 meses.',
      },
      {
        title:
          '¿Qué efectos secundarios puede tener la hidroxiapatita cálcica?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios de la hidroxiapatita cálcica son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones. Por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '2402D5F3-8A99-4C75-AB9B-C16461F2DE30', //Lifting
    candidateTitle: 'Paciente ideal para el Lifting',
    candiateText: `El Lifting Líquido está indicado para personas que desean mejorar la firmeza de la piel sin aportar volumen.

Es ideal para quienes:`,
    candidateBullets: [
      'Empiezan a notar flacidez facial o cervical',
      'Han perdido firmeza y colágeno',
      'Desean redefinir el óvalo facial o el contorno del cuello',
      'Buscan un efecto tensor natural',
      'Quieren revenir o corregir la flacidez de forma progresiva',
      'Desean un tratamiento médico rápido y eficaz',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación de hidroxiapatita cálcica es dolorosa?',
        description:
          'La aplicación de hidroxiapatita cálcica no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title:
          '¿Cuánto tiempo duran los resultados de la hidroxiapatita cálcica?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de la hidroxiapatita cálcica se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 12 meses.',
      },
      {
        title:
          '¿Qué efectos secundarios puede tener la hidroxiapatita cálcica?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios de la hidroxiapatita cálcica son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones. Por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '336C88DE-C8B9-4379-9D6C-08DB48DC8444', //Aumento labios
    candidateTitle: 'Paciente ideal para un aumento de labios',
    candiateText: `El aumento de labios está recomendado para quienes buscan volumen, definición o simetría, ya sea por estética, envejecimiento o falta de proyección natural. Este tratamiento estético es ideal si buscas:`,
    candidateBullets: [
      'Labios más voluminosos y armoniosos',
      'Corregir asimetrías labiales',
      'Hidratar y rejuvenecer la sonrisa',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [],
  },
  {
    id: '72083668-8840-4437-7E3D-08DB51474E0D', //Proyeccion pomulos
    candidateTitle: 'Paciente ideal para la Proyección de Pómulos',
    candiateText: `Este tratamiento es recomendable para quienes desean realzar sus facciones o recuperar el volumen perdido en la zona media del rostro.`,
    candidateBullets: [
      'Buscan pómulos más definidos y armónicos.',
      'Quieren corregir hundimientos o asimetrías.',
      'Desean un rejuvenecimiento inmediato sin cirugía.',
      'Tienen expectativas realistas.',
      'Son mayores de 18 años y gozan de buena salud.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [],
  },
  {
    id: '49A4A3D8-2B92-4808-FC04-08DB60F8A4D3', //Arrugas expresión: Frente, entrecejo y patas de gallo
    candidateTitle:
      'Paciente ideal para un tratamiento de arrugas de expresión',
    candiateText: `El tratamiento antiarrugas está recomendado para quienes desean suavizar líneas de expresión en frente, entrecejo o patas de gallo, logrando un aspecto rejuvenecido sin perder naturalidad. Este tratamiento estético es ideal si buscas:`,
    candidateBullets: [
      'Prevenir o suavizar arrugas en frente, entrecejo y patas de gallo',
      'Mantener la expresividad natural del rostro',
      'Efecto rejuvenecedor rápido y visible',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [],
  },
  {
    id: 'BBA65803-1C35-4584-A3ED-AB5358BF37FA', //Alidya Anticelulitico
    candidateTitle: 'Paciente ideal para Alidya anticelulítico',
    candiateText: `El tratamiento Alidya anticelulítico está recomendado para quienes buscan reducir la celulitis de forma eficaz, segura y sin cirugía y con resultados progresivos en la reducción de celulitis y grasa localizada, especialmente en casos de celulitis blanda. Este tratamiento estético es ideal si buscas:`,
    candidateBullets: [
      'Reducir la textura de piel de naranja en muslos, glúteos o abdomen',
      'Tratar la celulitis de grado 1 y 2',
      'Mejorar la firmeza, el tono y la elasticidad de la piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [],
  },
  {
    id: 'A0EB9872-F221-485C-A53A-08DB4C1D52CC', //Relleno de ojeras
    candidateTitle: 'Paciente ideal para el Relleno de Ojeras',
    candiateText: `Este tratamiento está indicado para quienes desean revitalizar la mirada, corregir hundimientos o suavizar ojeras oscuras, logrando un rostro más descansado y joven:`,
    candidateBullets: [
      'Quieren reducir el hundimiento bajo los ojos.',
      'Buscan una mirada más luminosa sin cirugía.',
      'Desean un rejuvenecimiento rápido y natural.',
      'Tienen expectativas realistas.',
      'Son mayores de 18 años y disfrutan de buena salud.',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '',
        description: '',
      },
    ],
  },
  {
    id: 'C64BC9B8-6709-4882-9019-444B5876D572', //Sudoración excesiva
    candidateTitle:
      'Paciente ideal para el tratamiento de sudoración excesiva ',
    candiateText: `El tratamiento para la sudoración excesiva está indicado para personas que sufren hiperhidrosis persistente, no vinculada al calor, el ejercicio físico o el nerviosismo, y que afecta a su calidad de vida. Este procedimiento médico solo se realiza en personas mayores de 18 años. 
 Este tratamiento médico es ideal si buscas:`,
    candidateBullets: [
      'Reducir la sudoración excesiva en axilas u otras zonas del cuerpo',
      'Mejorar tu comodidad y bienestar en el día a día',
      'Recuperar la seguridad y confianza en tu entorno personal y profesional ',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '',
        description: '',
      },
    ],
  },
  {
    id: '',
    candidateTitle: '',
    candiateText: `:`,
    candidateBullets: ['', '', '', '', '', ''],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados del ácido hialurónico se perciben de manera inmediata, aunque pueden estar condicionados por la inflamación. Sin embargo, los resultados del inyectable antiarrugas se empezarán a ver al cabo de 48 - 72 h. El resultado óptimo del tratamiento completo se verá a las tres semanas de la aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los productos aplicados se reabsorben durante seis o doce meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description:
          'La aplicación del tratamiento no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración, tan solo una posible hinchazón en el lugar de la inyección. Por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '8B44EC7A-25A0-496E-B22D-2ED4F3065DFA', //exoglowpeel
    candidateTitle: 'Paciente ideal para el Exoglow peel',
    candiateText: `El Exoglow peel está indicado para quienes buscan mejorar de forma integral la calidad, luminosidad y vitalidad de su piel con un tratamiento completo, seguro y sin tiempo de recuperación significativo. Ideal para quienes:`,
    candidateBullets: [
      'Quieren preparar su piel durante los meses de mayor exposición solar',
      'Buscan reducir manchas, tono irregular o piel apagada',
      'Desean mejorar la textura, firmeza y luminosidad de forma global',
      'Tienen la piel deshidratada, fatigada o con signos de envejecimiento',
      'Buscan un tratamiento con tecnología avanzada con resultados visibles desde la primera sesión',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '',
        description: '',
      },
    ],
  },
  {
    id: 'BB317525-8FE9-4373-9938-69E7F329FDAD', //exosomas
    candidateTitle: 'Paciente ideal para el Exosomas',
    candiateText: `El tratamiento de Exosomas está indicado para quienes buscan una regeneración celular real y profunda. Ideal para quienes:`,
    candidateBullets: [
      'Buscan una mejora progresiva y duradera de la calidad global de su piel',
      'Tienen la piel apagada, cetrina, deshidratada o con manchas',
      'Quieren preparar o reparar su piel tras la exposición solar',
      'Tienen la piel sensible, con inflamación o patologías no activas',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '',
        description: '',
      },
    ],
  },
  {
    id: 'E36B83A9-5E25-4CFB-3E1B-08DCA1B5F3D2', //harmonyca
    candidateTitle: 'Paciente ideal para Harmonyca',
    candiateText: `Harmonyca está recomendado para quienes quieren un resultado inmediato que se refuerce y prolongue con el tiempo, sin tener que elegir entre un relleno clásico y un inductor de colágeno. 

Es ideal para quienes:`,
    candidateBullets: [
      'Quieren ver un cambio desde el primer día y que ese resultado mejore progresivamente',
      'Buscan volumen y definición facial sin efecto artificial ni sobre voluminizado',
      'Tienen flacidez leve o moderada con pérdida de volumen en pómulos o tercio medio',
      'Desean el tratamiento más completo entre los inductores de colágeno, con acción inmediata y duradera',
      'Quieren redefinir el contorno mandibular y el óvalo facial en una única sesión',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Harmonyca?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de Harmonyca es dolorosa?',
        description:
          'La aplicación de Harmonyca no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Harmonyca?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '0EF5B0F9-AF63-49FA-9449-F8531D135424', //sculptra
    candidateTitle: 'Paciente ideal para Sculptra',
    candiateText: `Sculptra está recomendado para quienes priorizan la naturalidad y la longevidad del resultado por encima de la inmediatez. Es ideal para quienes:`,
    candidateBullets: [
      'Buscan una transformación real, progresiva y de muy larga duración',
      'Quieren el tratamiento más duradero entre los inductores de colágeno del mercado',
      'Tienen flacidez moderada con pérdida de flacidez en rostro, cuello o cuerpo',
      'Desean un rejuvenecimiento discreto y elegante',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Sculptra?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de Sculptra es dolorosa?',
        description:
          'La aplicación de Sculptra no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Sculptra?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'EDBBF557-8DE3-4B76-7C55-08DC5AB787B0', //Radiesse
    candidateTitle: 'Paciente ideal para Radiesse',
    candiateText: `Radiesse está recomendado para quienes quieren ver un cambio real desde el primer día y que ese resultado se prolongue y mejore con el tiempo. Es ideal para quienes:`,
    candidateBullets: [
      'Notan flacidez o descolgamiento facial',
      'Han perdido firmeza y densidad cutánea y buscan una mejora estructural',
      'Desean redefinir el óvalo facial o el contorno mandibular de forma natural',
      'Quieren combinar efecto tensor inmediato con la durabilidad de un inductor de colágeno',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Radiesse?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de Radiesse es dolorosa?',
        description:
          'La aplicación de Radiesse no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Radiesse?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '7185CCA4-1A6E-41FA-A81F-118B05EA7B53', //aumento gluteos
    candidateTitle: 'Paciente ideal para aumento de glúteos',
    candiateText: `El tratamiento de aumento de glúteos con ácido hialurónico está recomendado para quienes quieren potenciar sus curvas y mejorar la armonía corporal sin recurrir a la cirugía. 

Es ideal para quienes:`,
    candidateBullets: [
      'Quieren elevar, firmar o añadir volumen a los glúteos de forma natural',
      'Buscan corregir depresiones o irregularidades en la zona',
      'Desean un resultado inmediato con una recuperación mínima',
      'Prefieren una opción no quirúrgica, segura y reversible',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Sí, los resultados son visibles desde el mismo día del tratamiento, aunque pueden estar condicionados por la inflamación inicial. El resultado óptimo se aprecia a las tres semanas de su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del aumento de glúteos?',
        description:
          'Cada persona es única y también lo es su piel. En general, el ácido hialurónico se reabsorbe a partir de los 12 meses posteriores a la aplicación, aproximadamente.',
      },
      {
        title: 'La aplicación es dolorosa?',
        description:
          'El tratamiento puede resultar algo molesto, por eso siempre se aplica anestesia local previamente para garantizar el máximo confort durante el procedimiento.',
      },
      {
        title: '¿Qué efectos secundarios puede tener?',
        description:
          'Los efectos secundarios son leves y de corta duración: posible inflamación, hematomas o alguna irregularidad puntual durante los primeros días. Al no ser un tratamiento quirúrgico, podrás retomar tu rutina con normalidad en poco tiempo.',
      },
    ],
  },
  {
    id: 'F42B6B6E-F146-4D34-93DB-ACE1C1A5DA1B', // Firmeza gluteos - lanluma X
    candidateTitle: 'Paciente ideal para Firmeza en glúteos',
    candiateText: `El tratamiento Firmeza en glúteos está recomendado para quienes buscan recuperar firmeza y calidad en la zona glútea de forma natural, sin recurrir a la cirugía ni a implantes. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas pérdida de firmeza, volumen o tonificación en la zona glútea',
      'Buscas un resultado natural y progresivo',
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los tres meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en glúteos?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description:
          'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en glúteos?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'A0546373-CF6D-46B4-91C8-34C0E886E715', //Firmeza brazos - lanluma / sculptra
    candidateTitle: 'Paciente ideal para Firmeza en brazos',
    candiateText: `El tratamiento Firmeza en brazos está recomendado para quienes buscan recuperar firmeza en la zona del brazo de forma natural, sin recurrir a la cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas laxitud o flacidez cutánea en la parte superior del brazo',
      'Buscas un resultado natural y progresivo',
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los 3-6 meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en brazos?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description:
          'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en brazos?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'F998C402-1FAF-4BBF-9C74-8159028756E4', //Firmeza abdomen - lanluma / sculptra
    candidateTitle: 'Paciente ideal para Firmeza en abdomen',
    candiateText: `El tratamiento Firmeza en abdomen está recomendado para quienes buscan recuperar firmeza en la zona del brazo de forma natural, sin recurrir a la cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas pérdida de firmeza o flacidez en la zona abdominal',
      'Buscas un resultado natural y progresivo',
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los 3-6 meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en abdomen?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description:
          'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en abdomen?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'DB1610CE-D73F-40E0-A648-49FC1B09CCA4', //Firmeza muslos - lanluma / sculptra
    candidateTitle: 'Paciente ideal para Firmeza en muslos',
    candiateText: `El tratamiento Firmeza en muslos está recomendado para quienes buscan recuperar firmeza y calidad de piel en la zona del muslo o la rodilla de forma natural, sin recurrir a la cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas pérdida de firmeza o flacidez en la parte interior de los muslos o sobre las rodillas',
      'Buscas un resultado natural y progresivo',
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los 3-6 meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en muslos?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description:
          'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en muslos?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '75291FCF-BAA5-4564-9B9C-B5F103390EEB', //Firmeza escote - lanluma / sculptra / radiesse
    candidateTitle: 'Paciente ideal para Firmeza en escote',
    candiateText: `El tratamiento Firmeza en escote está recomendado para quienes buscan mejorar la calidad de la piel del escote de forma natural, sin recurrir a la cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas pérdida de calidad, arrugas o líneas finas en la zona del escote',
      'Buscas un resultado natural y progresivo',
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los 3-6 meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en escote?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description:
          'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en escote?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '', //Sudoracion excesiva pies
    candidateTitle:
      'Paciente ideal para el tratamiento de sudoración excesiva en pies ',
    candiateText: `El tratamiento para la sudoración excesiva en pies está indicado para personas que sufren hiperhidrosis plantar, no vinculada al calor, el ejercicio físico o el nerviosismo, y que afecta a su calidad de vida. Este tratamiento médico es ideal si buscas:`,
    candidateBullets: [
      'Reducir la sudoración excesiva en pies',
      'Mejorar tu comodidad y bienestar en el día a día',
      'Recuperar la seguridad y confianza en tu entorno personal y profesional',
      '',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados del ácido hialurónico se perciben de manera inmediata, aunque pueden estar condicionados por la inflamación. Sin embargo, los resultados del inyectable antiarrugas se empezarán a ver al cabo de 48 - 72 h. El resultado óptimo del tratamiento completo se verá a las tres semanas de la aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los productos aplicados se reabsorben durante seis o doce meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description:
          'La aplicación del tratamiento no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración, tan solo una posible hinchazón en el lugar de la inyección. Por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '', //sudoracion excesiva manos
    candidateTitle:
      'Paciente ideal para el tratamiento de sudoración excesiva en manos',
    candiateText: `El tratamiento para la sudoración excesiva en manos está indicado para personas que sufren hiperhidrosis palmar, no vinculada al calor, el ejercicio físico o el nerviosismo, y que afecta a su calidad de vida. Este tratamiento médico es ideal si buscas: `,
    candidateBullets: [
      'Reducir la sudoración excesiva en manos',
      'Mejorar tu comodidad y bienestar en el día a día',
      'Recuperar la seguridad y confianza en tu entorno personal y profesional',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description:
          'Los resultados del ácido hialurónico se perciben de manera inmediata, aunque pueden estar condicionados por la inflamación. Sin embargo, los resultados del inyectable antiarrugas se empezarán a ver al cabo de 48 - 72 h. El resultado óptimo del tratamiento completo se verá a las tres semanas de la aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description:
          'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los productos aplicados se reabsorben durante seis o doce meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description:
          'La aplicación del tratamiento no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description:
          'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración, tan solo una posible hinchazón en el lugar de la inyección. Por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'DD4CB824-00BB-4475-A702-2B3666FE2622', //Armonizacion Facial
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para la Armonización Facial',
    candiateText: 'Este tratamiento está indicado para quienes buscan mejorar la simetría del rostro, realzar sus rasgos y lograr un aspecto más armónico con una corrección sutil. Es ideal si:',
    candidateBullets: [
      'Deseas equilibrar proporciones faciales y potenciar tu belleza natural',
      'Buscas un rejuvenecimiento sin necesidad de cirugía',
      'Quieres redefinir contornos con resultados naturales',
      'Tienes expectativas realistas',
      'Eres mayor de 18 años y disfrutas de buena salud',
    ],
    candidateNote: 'El especialista valorará tu caso en consulta. En Holaglow disponemos de un escáner facial 3D gratuito para anticipar tus resultados con asesoramiento profesional. Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: 'Precio de la Armonización facial',
    priceText: `La armonización facial se adapta a cada paciente. El coste depende del pack y la personalización del tratamiento tras la valoración por un profesional.
- Armonización facial Basic: 2 viales de ácido hialurónico.
- Armonización facial: 3 viales de ácido hialurónico.`,
    priceBullets: [
      'Diagnóstico personalizado.',
      'Aplicación de ácido hialurónico por médicos especialistas',
      'Productos de calidad y efectivos',
      'Seguimiento y atención postratamiento 24/7',
    ],
    faqsTitle: 'Preguntas frecuentes sobre la Armonización Facial',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Sí. El ácido hialurónico ofrece un resultado visible desde el primer momento. Con los días, el producto se integra completamente en el tejido y el resultado final se aprecia con mayor naturalidad.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de la Armonización Facial?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados tienen una duración aproximada de entre 12 y 18 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener la Armonización Facial?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'D42F1676-5B3D-4E24-BC26-29331F8C4AB2', //Firmeza cuello
    candidateTitle: 'Paciente ideal para Firmeza en cuello',
    candiateText: `El tratamiento Firmeza en cuello está recomendado para quienes buscan mejorar la calidad de la piel del cuello de forma natural, sin recurrir a la cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Notas pérdida de calidad, arrugas o líneas finas en la zona del cuello', 
      'Buscas un resultado natural y progresivo', 
      'Quieres una mejora real y duradera en tu piel',
    ],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Los resultados son visibles de manera progresiva, no son evidentes desde el primer momento. El resultado óptimo del tratamiento se verá durante los 3-6 meses posteriores a su aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Firmeza en cuello?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, los resultados de los bioestimuladores de colágeno se desarrollan gradualmente durante los tres meses posteriores a su aplicación y su duración aproximada es de 14-18 meses.',
      },
      {
        title: '¿La aplicación de bioestimuladores de colágeno es dolorosa?',
        description: 'La aplicación de bioestimuladores de colágeno no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Firmeza en cuello?',
        description: 'Lo mejor de este tratamiento es que al ser mínimamente invasivo los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '2E65AB95-3C96-4D14-9B6A-6DA6BC50D267', //Pack wellaging
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para Pack Wellaging Basic',
    candiateText: 'El Pack Wellaging Basic está recomendado para quienes buscan un rejuvenecimiento facial completo y personalizable, combinando el efecto suavizante del inyectable antiarrugas con la capacidad de restauración de volumen del ácido hialurónico. Este tratamiento estético es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión en el tercio superior del rostro',
      'Has perdido volumen o firmeza en pómulos, labios u otras zonas faciales',
      'Buscas un resultado natural, progresivo y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre Pack Wellaging Basic',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Pack Wellaging Basic?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados del Pack Wellaging Basic tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación de Pack Wellaging Basic es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Pack Wellaging Basic?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '08F830F5-EFE2-4162-A5F3-6081460BBCD2', //Marcacion mandibular
    candidateTitle: 'Paciente ideal para la marcación mandibular',
    candiateText: `Este tratamiento está recomendado para quienes buscan definir el contorno mandibular y mejorar la armonía del tercio inferior del rostro sin recurrir a cirugía. Este tratamiento estético es ideal si:`,
    candidateBullets: [
      'Buscas una mandíbula más definida',
      'Notas pérdida de volumen o firmeza en la línea mandibular',
    ],
    candidateDisclaimer: `Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.`,
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Los resultados son inmediatos y visibles desde el primer momento, aunque pueden estar condicionados por la posible inflamación. El resultado óptimo del tratamiento se verá a las tres semanas de la aplicación.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del ácido hialurónico?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. Generalmente, el ácido hialurónico se reabsorbe durante los 6 o 12 meses posteriores a su aplicación.',
      },
      {
        title: '¿La aplicación de ácido hialurónico es dolorosa?',
        description: 'La aplicación de ácido hialurónico no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento de marcación mandibular?',
        description: 'Lo mejor de este tratamiento es que, al ser mínimamente invasivo, los efectos secundarios son muy leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o inflamaciones, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '668B678D-07AC-4431-8C44-4CF29D2D50C0', //Pérdida de peso GLP-1
    // Campos propios: títulos que no encajan con los genéricos de estética.
    procedureTitle: '¿Cómo funciona el tratamiento con GLP-1?',
    benefitsTitles: { 0: 'físicos', 2: 'en tu día a día' },
    candidateTitle: '¿Para quién está indicado el tratamiento GLP-1?',
    candiateText: '',
    // Párrafos separados (candiateText se pinta en uno solo).
    candidateParagraphs: [
      'El tratamiento GLP-1 puede ser una opción para personas que quieren perder peso y mejorar el control del apetito con un plan personalizado y seguimiento médico.',
      'Cada persona parte de un punto diferente. Por eso, antes de empezar realizamos una valoración para conocer tus objetivos y determinar si este tratamiento está indicado en tu caso.',
      'Tu objetivo es personal. Tu tratamiento también.',
      'Puede encajar contigo si:',
    ],
    candidateBullets: [
      'Quieres perder peso con acompañamiento médico',
      'Te cuesta controlar el apetito o la sensación de hambre',
      'Sientes que necesitas un apoyo adicional para alcanzar tu objetivo',
      'Has intentado perder peso anteriormente y buscas un enfoque diferente',
      'Quieres un tratamiento adaptado a ti y a tu evolución',
      'Buscas mejorar el control de tu peso a largo plazo',
    ],
    // Vacío: sin el aviso genérico de estética (escáner facial 3D).
    candidateNote: '',
    recommendations: {
      preTitle: 'Antes del tratamiento',
      preTips: [
        {
          priority: 1,
          icon: 'Medicamento',
          details:
            'Antes de iniciar el tratamiento se realizará una valoración médica completa. Es importante informar al profesional sobre tus antecedentes médicos, medicación habitual y cualquier condición de salud relevante.',
        },
      ],
      postTitle: 'Durante el tratamiento',
      postTips: [
        {
          priority: 1,
          icon: 'Inyeccion',
          details:
            'Sigue siempre las indicaciones del equipo médico y no modifiques la pauta por tu cuenta. Si notas algún efecto adverso o tienes dudas durante el proceso, contacta con nuestro equipo.',
        },
      ],
    },
    // Tarjetas de "Elige tu experiencia": la del precio y la cita gratis que se agenda.
    priceCard: {
      title: 'Pérdida de peso: GLP-1',
      description: '6 meses de asesoramiento personalizado',
    },
    freeAppointment: {
      title: 'Asesoramiento pérdida de peso',
      description:
        'Plan de tratamiento con análisis de hábitos y asesoramiento personalizado',
    },
    faqsTitle: 'Preguntas frecuentes sobre GLP-1 y pérdida de peso',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '¿Qué es el GLP-1 y para qué sirve?',
        description:
          'El GLP-1 es una hormona que participa en diferentes funciones del organismo, entre ellas la regulación del apetito y la sensación de saciedad. Existen tratamientos que actúan sobre esta vía y que pueden utilizarse, bajo indicación y supervisión médica, para ayudar al control y la pérdida de peso en determinados pacientes.',
      },
      {
        title: '¿Cómo ayuda el GLP-1 a perder peso?',
        description:
          'Los tratamientos GLP-1 actúan sobre mecanismos relacionados con el apetito y la saciedad. Pueden ayudar a sentir menos hambre y aumentar la sensación de plenitud después de comer, facilitando una reducción de la ingesta y contribuyendo a la pérdida de peso dentro de un abordaje médico personalizado.',
      },
      {
        title: '¿Cuánto peso se puede perder con GLP-1?',
        description:
          'La pérdida de peso con un tratamiento GLP-1 varía en cada persona. Depende de factores como el punto de partida, la respuesta individual al tratamiento, los hábitos y la evolución durante el seguimiento. Por eso, en Holaglow establecemos objetivos personalizados y valoramos periódicamente los resultados.',
      },
      {
        title: '¿Quién puede realizar un tratamiento con GLP-1?',
        description:
          'El tratamiento con GLP-1 puede ser una opción para personas que buscan perder peso, controlar mejor el apetito y alcanzar sus objetivos con acompañamiento médico. Cada caso es diferente, por eso realizamos una valoración previa para conocer tus necesidades y determinar si este tratamiento es adecuado para ti.',
      },
      {
        title: '¿Cuánto dura un tratamiento con GLP-1?',
        description:
          'No existe una duración igual para todos los pacientes. Generalmente entre 6 meses y un año. El tiempo de tratamiento dependerá de la indicación médica, la evolución, la tolerancia y los objetivos establecidos. Durante el seguimiento, el médico valorará de forma individualizada la continuidad y las posibles modificaciones del tratamiento.',
      },
      {
        title: '¿Cuándo se empiezan a notar los resultados del GLP-1?',
        description:
          'La respuesta al tratamiento puede variar entre pacientes, los casos empiezan a ser notorios entre las 3 y 8 semanas. Algunas personas pueden notar cambios en el apetito y la saciedad durante las primeras etapas, mientras que la evolución del peso se valora progresivamente durante el seguimiento. Los resultados no son inmediatos y deben evaluarse de forma individual.',
      },
      {
        title: '¿El tratamiento GLP-1 necesita receta médica?',
        description:
          'Los medicamentos GLP-1 utilizados para el control del peso son tratamientos sujetos a prescripción médica. Es necesario que un profesional sanitario valore previamente si existe una indicación adecuada y realice el seguimiento correspondiente.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el GLP-1?',
        description:
          'Como cualquier medicamento, los tratamientos GLP-1 pueden producir efectos adversos. Entre los descritos con mayor frecuencia se encuentran síntomas gastrointestinales como náuseas, vómitos, diarrea, estreñimiento o molestias abdominales, aunque pueden existir otros. El médico explicará los posibles efectos y valorará la tolerancia durante el seguimiento.',
      },
      {
        title: '¿Qué ocurre cuando se deja el tratamiento GLP-1?',
        description:
          'La evolución después de finalizar un tratamiento GLP-1 puede variar de una persona a otra. Por ello, la retirada debe plantearse junto con el médico y formar parte de una estrategia individualizada orientada al mantenimiento del peso y de los hábitos adquiridos durante el proceso.',
      },
      {
        title: '¿Se puede recuperar peso después de dejar el GLP-1?',
        description:
          'Sí, puede producirse una recuperación parcial o total del peso después de interrumpir el tratamiento, especialmente si vuelven a aparecer factores que favorecen una mayor ingesta. El acompañamiento médico y la consolidación de hábitos saludables son importantes para trabajar el mantenimiento de los resultados a largo plazo.',
      },
      {
        title: '¿Necesito hacer dieta durante el tratamiento con GLP-1?',
        description:
          'No es necesario realizar una dieta estricta pero sí un cambio de hábitos saludables. El tratamiento GLP-1 no debería entenderse como un sustituto de unos hábitos saludables. La alimentación, la actividad física y otros aspectos del estilo de vida forman parte del abordaje global del control del peso. Las recomendaciones deben adaptarse a las necesidades de cada paciente.',
      },
      {
        title: '¿El tratamiento GLP-1 es para todo el mundo?',
        description:
          'No. Existen situaciones en las que un tratamiento GLP-1 puede no estar indicado o requerir una valoración especial. Por eso, antes de comenzar es imprescindible realizar una consulta médica y revisar los antecedentes, el estado de salud y la medicación habitual.',
      },
      {
        title: '¿Cómo se administra el tratamiento GLP-1?',
        description:
          'La forma de administración depende del medicamento prescrito. Algunos tratamientos que actúan sobre la vía GLP-1 se administran mediante inyección subcutánea y la frecuencia puede variar según el fármaco. El médico indicará qué tratamiento y pauta son adecuados en cada caso.',
      },
      {
        title: '¿Dónde se administra la inyección de GLP-1?',
        description:
          'En los medicamentos GLP-1 de administración subcutánea, las zonas de inyección autorizadas dependen del medicamento concreto y de sus instrucciones de uso. El equipo médico explicará cómo administrarlo correctamente y cómo alternar las zonas cuando corresponda.',
      },
      {
        title: '¿Hay que hacer seguimiento médico durante el tratamiento GLP-1?',
        description:
          'Sí. El seguimiento médico permite valorar la evolución del peso, la respuesta y tolerancia al tratamiento y cualquier posible efecto adverso. También permite adaptar el abordaje a las necesidades del paciente a lo largo del proceso.',
      },
      {
        title: '¿Puedo empezar directamente un tratamiento GLP-1 para adelgazar?',
        description:
          'No debe iniciarse un tratamiento GLP-1 sin una valoración médica previa. En la primera consulta se estudian tus objetivos, antecedentes y estado de salud para determinar si existe indicación y cuál es el abordaje más adecuado.',
      },
      {
        title: '¿GLP-1 y Ozempic son lo mismo?',
        description:
          'No exactamente. GLP-1 hace referencia a una hormona y, en este contexto, a una familia o mecanismo de medicamentos que actúan sobre su receptor. Ozempic es una marca comercial concreta de semaglutida con indicaciones autorizadas específicas. No todos los medicamentos relacionados con GLP-1 son iguales ni tienen las mismas indicaciones.',
      },
      {
        title: '¿Cuál es el mejor tratamiento GLP-1 para perder peso?',
        description:
          'No existe un único tratamiento adecuado para todas las personas. La elección depende de la indicación autorizada de cada medicamento y de factores individuales como el estado de salud, antecedentes, objetivos y posibles contraindicaciones. El médico debe determinar qué opción es apropiada para cada paciente.',
      },
    ],
  },
  {
    id: '04E89D6C-FB2C-4D52-9AEB-0FD42AD9E0FF', //Full Face
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para Full Face',
    candiateText: 'El pack Full Face está recomendado para quienes buscan un rejuvenecimiento y una armonización completos del rostro, con un tratamiento integral y personalizable. Es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión, bolsas o signos de flacidez en varias zonas del rostro',
      'Has perdido volumen o firmeza en pómulos, labios u otras zonas faciales',
      'Buscas un resultado natural, progresivo y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre la armonización facial basic',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Sí. El ácido hialurónico ofrece un resultado visible desde el primer momento. Con los días, el producto se integra completamente en el tejido y el resultado final se aprecia con mayor naturalidad.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Full Face?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados tienen una duración aproximada de entre 12 y 18 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el Full Face?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '28996CF6-1C7B-4B04-AE4F-379685193727', //Pack Prevención
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Pack Prevención',
    candiateText: 'El Pack Prevención está recomendado para quienes quieren anticiparse al envejecimiento y mantener una piel saludable durante más tiempo. Es ideal si:',
    candidateBullets: [
      'Notas las primeras arrugas o líneas de expresión',
      'Quieres retrasar la aparición de signos de envejecimiento más marcados',
      'Buscas un resultado sutil, natural y adaptado a tus objetivos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Pack Prevención',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Sí. El ácido hialurónico ofrece un resultado visible desde el primer momento. Con los días, el producto se integra completamente en el tejido y el resultado final se aprecia con mayor naturalidad. El efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación del Pack Prevención es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'E28A2A32-BC6D-4AE4-84E5-8071A00F4FE3', //Pack Mirada
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Pack Mirada',
    candiateText: 'El Pack Mirada está recomendado para quienes quieren rejuvenecer y revitalizar la zona de la mirada. Es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión en la frente, el entrecejo o alrededor de los ojos',
      'Observas hundimiento en la zona de las ojeras o pérdida de volumen en los pómulos',
      'Buscas un resultado natural y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Pack Mirada',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación del Pack Mirada es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: 'D9C2D3EF-886C-4C82-AF53-232373B8398F', //Pack Redensity³ Skin
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Pack Redensity³ Skin',
    candiateText: 'El Pack Redensity³ Skin es recomendable para personas que buscan revitalizar su piel, prevenir signos de envejecimiento y recuperar la hidratación perdida por factores como el sol, la edad o el estrés. Es ideal si:',
    candidateBullets: [
      'Deseas mejorar la calidad de la piel',
      'Quieres un aspecto más luminoso y descansado',
      'Buscas prevenir la aparición de arrugas tempranas',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Pack Redensity³ Skin',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'La piel se ve más hidratada desde la primera sesión, aunque el efecto revitalizante y la mejora en la textura y la luminosidad se hacen más visibles de forma progresiva, a medida que se estimula la producción de colágeno y elastina a lo largo de las tres sesiones.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del tratamiento?',
        description: 'Cada piel es distinta y responde de forma diferente al tratamiento. En general, los resultados tienen una duración aproximada de entre 12 y 18 meses.',
      },
      {
        title: '¿La aplicación del Pack Redensity³ Skin es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el tratamiento?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '41FD1F90-5402-44D5-A08A-1F9351ED8B2A', //Pack Wellaging Esencial
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para Pack Wellaging Esencial',
    candiateText: 'El Pack Wellaging Esencial está recomendado para quienes buscan un rejuvenecimiento facial completo y personalizable, combinando el efecto suavizante del inyectable antiarrugas con la capacidad de restauración de volumen del ácido hialurónico. Este tratamiento estético es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión en el tercio superior del rostro',
      'Has perdido volumen o firmeza en pómulos, labios u otras zonas faciales',
      'Buscas un resultado natural, progresivo y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre Pack Wellaging Esencial',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Pack Wellaging Esencial?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados del Pack Wellaging Esencial tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación de Pack Wellaging Esencial es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Pack Wellaging Esencial?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '78419F83-1C16-458E-96DC-1A59D4A8C322', //Pack Wellaging Plus
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para Pack Wellaging Plus',
    candiateText: 'El Pack Wellaging Plus está recomendado para quienes buscan un rejuvenecimiento facial completo y personalizable, combinando el efecto suavizante del inyectable antiarrugas con la capacidad de restauración de volumen del ácido hialurónico. Este tratamiento estético es ideal si:',
    candidateBullets: [
      'Notas arrugas de expresión en el tercio superior del rostro',
      'Has perdido volumen o firmeza en pómulos, labios u otras zonas faciales',
      'Buscas un resultado natural, progresivo y adaptado a tus objetivos concretos',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre Pack Wellaging Plus',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'El ácido hialurónico ofrece un resultado visible desde el primer momento, mientras que el efecto del inyectable antiarrugas se desarrolla progresivamente durante los días posteriores a la aplicación, alcanzando su resultado óptimo en torno a las dos semanas.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de Pack Wellaging Plus?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados del Pack Wellaging Plus tienen una duración aproximada de entre 6 y 12 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación de Pack Wellaging Plus es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener Pack Wellaging Plus?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '008676A6-AF05-4532-AEFD-C116C784FC25', //Reparative Pack
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para el Reparative Pack',
    candiateText: 'El Reparative Pack está recomendado para quienes buscan renovar su piel y mejorar su calidad de forma progresiva, con un protocolo adaptado a sus objetivos. Es ideal si:',
    candidateBullets: [
      'Notas manchas, tono desigual o daño solar en la piel',
      'Tienes poros dilatados, cicatrices de acné o textura irregular',
      'Quieres suavizar arrugas finas y líneas de expresión',
      'Buscas mejorar la firmeza y la luminosidad de tu piel sin cirugía',
    ],
    candidateNote: 'Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre el Reparative Pack',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Tras las primeras sesiones puedes notar la piel más suave y luminosa, aunque los resultados se hacen más visibles de forma progresiva, a medida que avanzan las sesiones y se estimula la producción de colágeno y elastina.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados del Reparative Pack?',
        description: 'Cada piel es distinta y responde de forma diferente al tratamiento. En general, los resultados tienen una duración aproximada de entre 6 y 12 meses, dependiendo del tipo de piel y de los cuidados posteriores.',
      },
      {
        title: '¿La aplicación del Reparative Pack es dolorosa?',
        description: 'Se trata de tratamientos no invasivos y bien tolerados, aunque puedes notar una ligera molestia durante las sesiones. El umbral del dolor es distinto para cada persona, así que coméntalo con el especialista antes de empezar.',
      },
      {
        title: '¿Qué efectos secundarios puede tener el Reparative Pack?',
        description: 'Al ser un tratamiento no invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son rojeces, sensibilidad o ligera descamación en la zona tratada, que se resuelven en pocos días.',
      },
    ],
  },
  {
    id: '24CF518B-0686-4D9E-AA63-7414112BA006', //Armonizacion Facial Basic
    procedureTitle: 'Procedimiento médico',
    candidateTitle: 'Paciente ideal para la Armonización Facial Basic',
    candiateText: 'Este tratamiento está indicado para quienes buscan mejorar la simetría del rostro, realzar sus rasgos y lograr un aspecto más armónico con una corrección sutil. Es ideal si:',
    candidateBullets: [
      'Deseas equilibrar proporciones faciales y potenciar tu belleza natural',
      'Buscas un rejuvenecimiento sin necesidad de cirugía',
      'Quieres redefinir contornos con resultados naturales',
      'Tienes expectativas realistas',
      'Eres mayor de 18 años y disfrutas de buena salud',
    ],
    candidateNote: 'El especialista valorará tu caso en consulta. En Holaglow disponemos de un escáner facial 3D gratuito para anticipar tus resultados con asesoramiento profesional. Este procedimiento estético solo se realiza en personas mayores de 18 años por un médico especialista, con una previa valoración individual de cada paciente. No está indicado en personas con alergias severas, infecciones cutáneas activas o enfermedades sistémicas.',
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqsTitle: 'Preguntas frecuentes sobre la Armonización Facial Basic',
    faqs: [
      {
        title: '¿Podré ver los resultados de manera instantánea?',
        description: 'Sí. El ácido hialurónico ofrece un resultado visible desde el primer momento. Con los días, el producto se integra completamente en el tejido y el resultado final se aprecia con mayor naturalidad.',
      },
      {
        title: '¿Cuánto tiempo duran los resultados de la Armonización Facial Basic?',
        description: 'Cada uno de nosotros es único y también lo es nuestra piel. En general, los resultados tienen una duración aproximada de entre 12 y 18 meses, dependiendo de la zona tratada y del metabolismo de cada paciente.',
      },
      {
        title: '¿La aplicación del tratamiento es dolorosa?',
        description: 'La aplicación no es dolorosa. De todos modos, el umbral del dolor es distinto para cada persona, por lo que estaremos encantados de aplicar anestésico tópico, si lo deseas.',
      },
      {
        title: '¿Qué efectos secundarios puede tener la Armonización Facial Basic?',
        description: 'Al ser un tratamiento mínimamente invasivo, los efectos secundarios son leves y de corta duración. Los más comunes son la aparición de hematomas, moretones o pequeñas inflamaciones en las zonas tratadas, por lo que podrás continuar con tu rutina sin complicaciones.',
      },
    ],
  },
  {
    id: '', //
    candidateTitle: '',
    candiateText: ``,
    candidateBullets: ['', '', '', ''],
    priceTitle: '',
    priceText: ``,
    priceBullets: [],
    faqs: [
      {
        title: '',
        description: '',
      },
    ],
  },
];
